module.exports = __webpack_public_path__ + "static/summer-tanager-abb534e7ecd44b774dc5d1d921f40019.jpg";